import { GzDashboardLoadingScreenWebComponent } from './component/GzDashboardLoadingScreenWebComponent';
import { WEB_COMPONENT_GZ_DASHBOARD_LOADING_SCREEN } from '../../webcomponents.constants';

export { GzDashboardLoadingScreenWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_DASHBOARD_LOADING_SCREEN, GzDashboardLoadingScreenWebComponent);
